import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['trigger'];

  toggle() {
    this.triggerTarget.setAttribute(
      'aria-expanded',
      this.triggerTarget.getAttribute('aria-expanded') === 'true'
        ? 'false'
        : 'true'
    );
  }
}
